module.exports = __webpack_public_path__ + "img/9788992844031.ba654d66.jpg";